import { UiModel } from '@durlabh/dframework-ui';
import { useParams } from 'react-router';
import documentConfig from './childGrids/Document';
const DocumentModel = new UiModel({ ...documentConfig, readOnly: false });
const mapper = {
    masterScope: "Scope",
    equipments: "Equipment",
    revision: "Revision"
};
function AddDocumentForm({ documentGroupMap }) {
    const { associationId, documentGroup } = useParams();
    return (documentGroupMap &&
        <DocumentModel.Form baseSaveData={{
            AssociationId: parseInt(associationId),
            DocumentGroupId: documentGroupMap[mapper[documentGroup]]
        }} />
    );
}

export default AddDocumentForm;
